import { useNavigate, useParams } from 'react-router-dom';
import { SecurityGroupForm } from '../components/SecurityGroupForm';
import { useSecurityGroupQuery } from '../hooks/useSecurityGroupQuery';
import { useSecurityGroupMutations } from '../hooks/useSecurityGroupMutations';
import { Alert } from '@shared/components';

export function SecurityGroupEdit() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const query = useSecurityGroupQuery(id);
  const { updateMutation } = useSecurityGroupMutations(id);

  if (!id) return <p className="text-mp-error">Invalid security group ID.</p>;
  if (query.isLoading) return <p>Loading...</p>;
  if (query.isError || !query.data) {
    return (
      <Alert variant="error">
        <span>Security group not found or failed to load.</span>
      </Alert>
    );
  }

  const group = query.data;

  return (
    <section className="space-y-4">
      <h1 className="text-2xl font-semibold">Edit Security Group</h1>
      <SecurityGroupForm
        mode="edit"
        initialValues={{ name: group.name, invoicing_mode: group.invoicing_mode }}
        productsCount={group.products_count ?? 0}
        onSubmit={(data) =>
          updateMutation.mutate(
            { id: id!, payload: data },
            {
              onSuccess: () => navigate(`/admin/security-groups/${id}`),
            },
          )
        }
        isLoading={updateMutation.isPending}
        submitLabel="Save Changes"
      />
    </section>
  );
}
